import { render, staticRenderFns } from "./break-list.vue?vue&type=template&id=280a3f94&scoped=true&"
import script from "./break-list.vue?vue&type=script&lang=js&"
export * from "./break-list.vue?vue&type=script&lang=js&"
import style0 from "./break-list.vue?vue&type=style&index=0&id=280a3f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a3f94",
  null
  
)

export default component.exports